import React from 'react';
import compose from 'recompose/compose';
import { actionCreators } from '../../../store/DebtorLeapClaimsStore';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { ApplicationState } from '../../../store';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { DebtorClaim, ResultOfDebtorIndex } from '../../../api/client';
import { getDebtorIdsFromQueryString, getLeapClaimSystemDebtorIds, getCaseNumbersFromQueryString } from '../../../components/Utils';
import DebtorClaimComponent from '../../../components/debtorOverview/containers/DebtorClaim';
import { getDebtorClaims } from '../../../store/Selectors';

interface PropsFromState {
  debtorClaims: DebtorClaim[];
  selectedResult?: ResultOfDebtorIndex | null;
  isLoadingDebtorClaims: boolean;
}

interface PropsFromDispatch {
  clearDebtorLeapClaims: typeof actionCreators.clearLeapClaims;
  getDebtorLeapClaims: typeof actionCreators.getLeapClaimsByDebtorIds;
  getLeapClaimsByCaseNumbersForDebtor: typeof actionCreators.getLeapClaimsByCaseNumbersForDebtor;
}

interface InjectedProps extends RouteComponentProps {
}

type ComponentProps = PropsFromState & PropsFromDispatch & InjectedProps;

class DebtorClaimsList extends React.Component<ComponentProps> {
  private get isClaimsRoute() {
    return this.props.location.pathname === '/claims';
  }

  componentDidMount() {
    const debtorIds: Array<string> = getDebtorIdsFromQueryString(this.props.location);
    if (this.isClaimsRoute) {
      const caseNumbers: Array<string> = getCaseNumbersFromQueryString(this.props.location);
      this.props.getLeapClaimsByCaseNumbersForDebtor(debtorIds[0], caseNumbers);
    }
    else {
      this.props.getDebtorLeapClaims(getLeapClaimSystemDebtorIds(debtorIds));
    }
  }

  componentWillUnmount() {
    this.props.clearDebtorLeapClaims();
  }

  public render() {
    return (
      <React.Fragment>
        {this.props.isLoadingDebtorClaims ?
          <CircularProgress
            sx={{ margin: '0 auto', display: 'block' }}
            size={75}
            data-testid="debtorclaimslist-progress" /> :
            this.props.debtorClaims.length === 0 &&
            <Box sx={{
              margin: '0 auto',
              width: '500px',
              marginBottom: '10px',
            }}>
              <Typography variant="h6">
                Debitor har ingen fakturaer eller inkassosaker
              </Typography>
            </Box>
        }
        {this.props.debtorClaims.filter(x => x.isTopLevelClaim).map((item, i) => (
          <DebtorClaimComponent key={i} debtorClaim={item} isTopLevel={true} expanded={this.isClaimsRoute} />
        ))}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: ApplicationState): PropsFromState => ({
  debtorClaims: getDebtorClaims(state),
  selectedResult: state.debtorSearch.selectedResult,
  isLoadingDebtorClaims: state.debtorLeapClaims.isLoading,
});

const mapDispatchToProps: PropsFromDispatch = {
  clearDebtorLeapClaims: actionCreators.clearLeapClaims,
  getDebtorLeapClaims: actionCreators.getLeapClaimsByDebtorIds,
  getLeapClaimsByCaseNumbersForDebtor: actionCreators.getLeapClaimsByCaseNumbersForDebtor,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(withRouter(DebtorClaimsList));
